<template>
	<div class="ccs-logo-tabs" role="tablist">
		<tab-item v-for="(tab, index) in items"
				   :tab="tab"
				   :is-active="index === current"
				   :key="index"
				   @click="tabClick(index)" />
	</div>
</template>

<script>
	import tabItem from "./tab-item.vue";

	export default {
		components: { tabItem },
		props: {
			items: Array
		},
		data() {
			return {
				current: 0
			}
		},
		methods: {
			tabClick(index) {
				if (this.current !== index) {
					this.current = index;
					this.$emit('changed', this.items[this.current]);
				}
			}
		}
	}
</script>

<style scoped>
	.ccs-logo-tabs {
		display: flex;
		flex-grow: 1;
		max-width: 100%;
		align-self: flex-end;
	}
</style>
